import { render, staticRenderFns } from "./ProgramMemberResultComponent.vue?vue&type=template&id=22be0142&"
import script from "./ProgramMemberResultComponent.vue?vue&type=script&lang=js&"
export * from "./ProgramMemberResultComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports